var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.721,
    height: 64,
    viewBox: "0 0 45.721 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_683",
    "data-name": "Grupo 683",
    transform: "translate(-924.967 -2675)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_235",
    "data-name": "Trazado 235",
    d: "M452.337,422.59a4.592,4.592,0,0,0-4.587-4.57h-9.173a4.592,4.592,0,0,0-4.587,4.57v45.7h.115a2.088,2.088,0,0,0,.275,1.165l6.559,11.333a2.31,2.31,0,0,0,2,1.142h.138c.092,0,.183.046.275.046a2.31,2.31,0,0,0,2-1.142l6.582-11.333a2.356,2.356,0,0,0,.275-1.165h.161V422.59Zm-13.76,9.14h9.173v31.988h-9.173Zm0-9.14h9.173v4.57h-9.173Zm4.564,52.872-4.151-7.175h8.3Z",
    transform: "translate(518.327 2257.026)",
    fill: "#00c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_236",
    "data-name": "Trazado 236",
    d: "M440.337,418h-13.76a4.592,4.592,0,0,0-4.587,4.57v54.837a4.592,4.592,0,0,0,4.587,4.57h13.76a4.592,4.592,0,0,0,4.587-4.57V422.57A4.592,4.592,0,0,0,440.337,418Zm0,59.407h-13.76v-9.14h6.88a2.285,2.285,0,1,0,0-4.57h-6.88v-4.57h2.293a2.285,2.285,0,1,0,0-4.57h-2.293v-4.57h6.88a2.285,2.285,0,1,0,0-4.57h-6.88v-4.57h2.293a2.285,2.285,0,1,0,0-4.57h-2.293v-4.57h6.88a2.285,2.285,0,1,0,0-4.57h-6.88v-4.57h13.76Z",
    transform: "translate(502.977 2257)",
    fill: "#00c1d4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducacion);
export default __webpack_public_path__ + "static/media/educacion.52912511250fa479dc889366569b3b2e.svg";
export { ForwardRef as ReactComponent };